import { render, staticRenderFns } from "./extra-my-details.vue?vue&type=template&id=4b297880&scoped=true&lang=pug&"
import script from "./extra-my-details.vue?vue&type=script&lang=js&"
export * from "./extra-my-details.vue?vue&type=script&lang=js&"
import style0 from "./extra-my-details.vue?vue&type=style&index=0&id=4b297880&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b297880",
  null
  
)

export default component.exports